import { paths } from 'src/routes/paths';

import packageJson from '../package.json';

// ----------------------------------------------------------------------

export type ConfigValue = {
  appName: string;
  appVersion: string;
  serverUrl: string;
  assetsDir: string;
  alvineBaseUrl: string;
  externalLoginUrl: string;
  smedexWebsiteUrl: string;
  supportEmail: string;
  auth: {
    method: 'jwt';
    redirectPath: string;
  };
  swagger: {
    enabled: boolean;
    url: string;
  };
  sentry: {
    dsn: string;
  };
};

// ----------------------------------------------------------------------

export const CONFIG: ConfigValue = {
  appName: 'Smedex Next',
  appVersion: packageJson.version,
  serverUrl: import.meta.env.VITE_SERVER_URL ?? '',
  assetsDir: import.meta.env.VITE_ASSETS_DIR ?? '',
  alvineBaseUrl: import.meta.env.VITE_ALVINE_BASE_URL ?? '',
  externalLoginUrl: import.meta.env.VITE_EXTERNAL_LOGIN_URL ?? '',
  smedexWebsiteUrl: import.meta.env.VITE_SMEDEX_WEBSITE_URL ?? '',
  supportEmail: 'support@smedex.com',
  auth: {
    method: 'jwt',
    redirectPath: paths.dashboard.root,
  },
  swagger: {
    enabled: import.meta.env.VITE_SWAGGER_ENABLED === 'true',
    url: import.meta.env.VITE_SWAGGER_URL ?? '',
  },
  sentry: {
    dsn:
      import.meta.env.VITE_SENTRY_DSN ||
      'https://af153bc7530acde92be92913ccf84c04@o4508421251530752.ingest.de.sentry.io/4511490317156432',
  },
};
